var exports = {
  "k": "xa15a2ab7--188a13--container",
};

module.exports = exports;
